import TrameSaisieFormController from './trame.saisie.form.controller';

export default {
    template: require('./trame.saisie.form.html'),
    controller: TrameSaisieFormController
};
